import React, { useMemo, useState } from 'react';

import { useGetVmsSources } from '@vlabs/api/point-api/client';
import type { GetVmsSourcesParams } from '@vlabs/api/point-api/model';
import { Table } from '@vlabs/uikit';
import { Button } from '@vlabs/uikit/components/controls/button/Button';
import { DEFAULT_PAGE_SIZE } from '@vlabs/uikit/constants';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { VmsInputCell } from './VmsInputCell.jsx';

function VmsListTable(): React.ReactNode {
  const [filters, setFilters] = useState<GetVmsSourcesParams>({
    page: 0,
    page_size: DEFAULT_PAGE_SIZE,
  });
  const getVmsSources = useGetVmsSources(filters);

  const { t } = useTranslation();
  const columns = useMemo(
    () => {
      return [
        { Header: t('vms:таблица.колонки.vendor'), accessor: 'vendor', width: 80 },
        { Header: t('vms:таблица.колонки.vms_id'), accessor: 'vendor_uuid', width: 80 },
        { Header: t('vms:таблица.колонки.vms_name'), accessor: 'vendor_name', width: 80 },
        {
          Header: t('vms:таблица.колонки.luna_name.title'),
          accessor: 'luna_name',
          // eslint-disable-next-line react/no-unstable-nested-components
          Cell: (data) => (<VmsInputCell row={data?.row?.values} />),
          width: 100,
        },
      ];
    },
    [t],
  );

  const renderButtons = () => (
    <Button onClick={getVmsSources.refetch}>
      {t('vms:таблица.обновить')}
    </Button>
  );

  return (
    <Table
      columns={columns}
      data={getVmsSources.data?.vms_sources ?? []}
      extraButtons={renderButtons}
      pageIndex={filters.page}
      pageSize={filters.page_size}
      paginationType="offsetBased"
      setPageIndex={(newPageIndex) => {
        setFilters((prevFilters) => {
          if (prevFilters.page === newPageIndex) return prevFilters;
          return { ...prevFilters, page: newPageIndex };
        });
      }}
      setPageSize={(newPageSize) => {
        setFilters((prevFilters) => {
          if (prevFilters.page_size === newPageSize) return prevFilters;
          return { ...prevFilters, page_size: newPageSize };
        });
      }}
    />
  );
}

VmsListTable.defaultProps = {
};

export default connect(() => ({
}), () => ({
}))(VmsListTable);
